import { Button, ErrorAlert, FormError, Notice, TextInput, linkStyles, useTextForm } from '@lumlab/platform-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { authClient } from '../app/auth.ts';
import { AuthScreen, authErrorCode } from '../app/AuthScreen.tsx';

export function ForgotPasswordPage() {
    const { t } = useTranslation();
    const [error, setError] = useState<{ code: string } | null>(null);
    const [pending, setPending] = useState(false);
    const [sent, setSent] = useState(false);
    const form = useTextForm({ initialValues: { email: '' } });

    const submit = form.onSubmit(async ({ email }) => {
        setPending(true);
        setError(null);
        try {
            const result = await authClient.requestPasswordReset({ email: email.trim() });
            // The answer is the same whether an account exists or not.
            if (result.error) setError({ code: authErrorCode(result.error) });
            else setSent(true);
        } catch {
            setError({ code: 'internal' });
        } finally {
            setPending(false);
        }
    });

    return (
        <AuthScreen title={t('platform.auth.forgotPassword.title')}>
            {sent ? (
                <Notice tone="success">{t('platform.auth.forgotPassword.sent')}</Notice>
            ) : (
                <form onSubmit={submit} className="flex flex-col gap-4">
                    <FormError message={form.formError} />
                    <p className="text-sm text-muted">{t('platform.auth.forgotPassword.intro')}</p>
                    {error && <ErrorAlert error={error} />}
                    <TextInput
                        type="email"
                        autoComplete="email"
                        required
                        label={t('platform.auth.email')}
                        {...form.getInputProps('email')}
                    />
                    <Button type="submit" loading={pending}>
                        {t('platform.auth.forgotPassword.submit')}
                    </Button>
                </form>
            )}
            <Link to="/sign-in" className={`text-sm ${linkStyles}`}>
                {t('platform.auth.backToSignIn')}
            </Link>
        </AuthScreen>
    );
}
